import React, {Component} from "react"
import {connect} from "react-redux"
import fetch from 'isomorphic-fetch'
import op from "object-path"
import Select from 'react-select'
import config from "../config"
import {PATH_USER_SEARCH} from '../constants'

function mapStateToProps(state, ownProps) {

  const user = state.user
  return {
    user
  }
}

const mapDispatchToProps = {}


class AsyncUserMultiSelect extends Component {
  render() {

    const {api_server_host} = config

    const token = this.props.user.access_token
    const type = this.props.user.token_type

    const excludedUserIds = new Set(this.props.excludedUserIds || [])

    const getOptions = (input) => {
      return fetch(`${api_server_host}${PATH_USER_SEARCH}?query=${input.trim()}`
        ,{
          headers: {
            Authorization: `${type} ${token}`
          }
        })
        .then((response) => {
          return response.json();
        }).then((json) => {
          const options = json? json.filter((u)=>!excludedUserIds.has(u.id)).map((u)=>({value:u.id, label:u.emailAddress})):[]
          return { options: options.sort((it)=>it.label), complete: true };
        });
    }

    return (
      <Select.Async
        className={this.props.className}
        name={this.props.name}
        multi
        value={this.props.value}
        onChange={this.props.onChange}
        loadOptions={getOptions}
      />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AsyncUserMultiSelect)



// WEBPACK FOOTER //
// ./src/components/AsyncUserMultiSelect.js